import {
    addProfile,
    CamelCaseNamingConvention,
    createMapper,
} from '@automapper/core';
import { IQueryParamsMetadata, IQueryParamsSymbol } from '@pf/shared-common';
import {
    ResourceAuthMetadataMap,
    withResourceAuthMetadata,
    withTypeEntityMetadata,
} from '@pf/shared/util-platform';

import { pojos } from '@automapper/pojos';
import { withMetadata } from '@pf/shared-utility';
import { PurchaseOrderHeaderMetadataMap } from './purchase-order-headers/purchase-order-header.mapping-profile';
import { PurchaseOrderLineMetadataMap } from './purchase-order-lines/purchase-order-line.mapping-profile';

/** Global Metadata */
withMetadata(IQueryParamsSymbol, IQueryParamsMetadata);
withTypeEntityMetadata();
withResourceAuthMetadata();

/** Create mapper */
export const PlatformOrdersMapper = createMapper({
    strategyInitializer: pojos(),
    namingConventions: new CamelCaseNamingConvention(),
});

/** Add mapping profiles */
addProfile(PlatformOrdersMapper, ResourceAuthMetadataMap.profile);
addProfile(PlatformOrdersMapper, PurchaseOrderHeaderMetadataMap.profile);
addProfile(PlatformOrdersMapper, PurchaseOrderLineMetadataMap.profile);
